import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';

import IconPanel from '../IconPanel';
import useVerificationLogin from './useVerificationLogin';

import securityIcon from '../../images/icons/security.svg';

const LoginToContinue = (): JSX.Element => {
  const logIn = useVerificationLogin();

  return (
    <IconPanel
      translationKey='components.Verification.LoginToContinue'
      icon={<img src={securityIcon} alt='' width={62} height={62} />}
      noInfo
      detailsCentered
      data-testid='verification-login-to-continue'
    >
      <div className='text-center'>
        <M.Button
          kind='primary'
          type='button'
          onClick={logIn}
          data-testid='verification-login-button'
        >
          <T value='components.Verification.LoginToContinue.button' />
        </M.Button>
      </div>
    </IconPanel>
  );
};

export default LoginToContinue;
